module.exports = __webpack_public_path__ + "static/media/grain-feed-section.7ffa9d64.png";